export const gridCanvasConfig = {
  canvas: null,
  ctx: null,
  path: null,
};
